<template>
  <v-card flat>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col>
            <v-file-input v-model="fileObj"
              label="Add a document" :disabled="loading" :loading="loading"
              prepend-icon="add" @change="upload"
              outlined>
            </v-file-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-list>
              <template v-for="doc in documents">
                <v-list-item :key="doc.id">
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="10">
                        <v-btn style="text-transform:none" text outlined block :href="doc.document" target="_blank">{{ doc.name }}</v-btn>
                      </v-col>
                      <v-col cols="2">
                        <v-btn icon @click="remove(doc.id)">
                          <v-icon>delete_outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import EntityService from '@/services/EntityService'

@Component
export default class DocumentManager extends Vue {
  @Prop(Number) itemId

  loading = false
  documents = []
  fileObj = null

  mounted () {
    if (this.itemId) {
      this.load()
    }
  }

  load () {
    EntityService.getDocuments(this.itemId)
      .then(resp => {
        this.documents = resp.data.results || resp.data
      })
  }

  upload () {
    let formData = new FormData()
    formData.append('file', this.fileObj)

    this.loading = true
    EntityService.upload(this.itemId, formData)
      .then(resp => {
        this.fileObj = null
        this.load()
      })
      .finally(() => {
        this.loading = false
      })
  }

  remove (id) {
    EntityService.deleteDocument(this.itemId, id)
      .then(resp => {
        this.load()
      })
  }
}
</script>
